(function () {
  document.querySelectorAll('[data-lg-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-lg-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('.lg-accordion__item').forEach(function (item) {
    var trigger = item.querySelector('.lg-accordion__trigger');
    trigger.addEventListener('click', function () {
      var isOpen = item.getAttribute('data-open') === 'true';
      item.closest('.lg-accordion').querySelectorAll('.lg-accordion__item').forEach(function (other) {
        other.setAttribute('data-open', 'false');
      });
      item.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  });

  var stickyCta = document.querySelector('.lg-sticky-cta');
  if (stickyCta) {
    window.addEventListener('scroll', function () {
      stickyCta.setAttribute('data-visible', window.scrollY > 800 ? 'true' : 'false');
    });
  }
})();
